export default __webpack_public_path__ + "static/media/mobilecomm_logo.94757144.png";